import { Locale, type LocalizedString } from "../Locale.js";

export const referencesPathMap = {
	[Locale.cs]: "reference" as const,
} satisfies LocalizedString;
